import { Button, Typography, Box } from '@mui/material';

interface VerifyAccountProps {
  setActivePage: (value: string) => void;
}

export const VerifyAccount = (props: VerifyAccountProps) => {
  const { setActivePage } = props;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <Typography sx={{ margin: '24px', textAlign: 'center' }}>
        Check your email for a verification link. Once verified, click the
        button below to sign in.
      </Typography>
      <Button
        sx={{ backgroundColor: 'white' }}
        variant="outlined"
        onClick={() => setActivePage('login')}
      >
        Sign In
      </Button>
    </Box>
  );
};
